import { render, staticRenderFns } from "./InsuranceCompanyInfo.vue?vue&type=template&id=1d471b05&scoped=true&"
import script from "./InsuranceCompanyInfo.vue?vue&type=script&lang=js&"
export * from "./InsuranceCompanyInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d471b05",
  null
  
)

export default component.exports